import { apiCall } from "../../../../utils/apiCall";
import { header } from "../../utils/salesAdminHeader";

type Base64FileFromApi = {
  fileName: string;
  base64File: string;
};

type UploadFileType = {
  uid: string;
  name: string;
  url?: string;
  originFileObj?: File;
};

export const convertAllFilesToApiFormat = async (
  imageFiles: UploadFileType[],
  attachmentFiles: UploadFileType[]
): Promise<{
  images: Base64FileFromApi[];
  files: Base64FileFromApi[];
}> => {
  const toBase64 = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const extractUrlFiles = (list: UploadFileType[]) =>
    list.filter((file) => !file.originFileObj && file.url);

  const imageUrlFiles = extractUrlFiles(imageFiles);
  const attachmentUrlFiles = extractUrlFiles(attachmentFiles);
  const allUrlFiles = [...imageUrlFiles, ...attachmentUrlFiles];

  let response: Base64FileFromApi[] = [];

  if (allUrlFiles.length > 0) {
    response = await apiCall({
      method: "POST",
      header,
      endPoint: process.env.REACT_APP_SALES_ADMIN + "/files/admin/base64",
      payload: {
        blobUrls: allUrlFiles.map((f) => f.url as string),
      },
    });
  }

  const fileMap: Map<string, Base64FileFromApi> = new Map();
  response.forEach((res: Base64FileFromApi, i: number) => {
    const url = allUrlFiles[i].url;
    if (url) fileMap.set(url, res);
  });

  const convertFile = async (
    file: UploadFileType
  ): Promise<Base64FileFromApi> => {
    const base64 = await toBase64(file.originFileObj as File);
    return {
      fileName: file.name,
      base64File: base64.split(",")[1],
    };
  };

  const images = await Promise.all(
    imageFiles.map(async (file) => {
      if (file.originFileObj) return await convertFile(file);
      const matched = fileMap.get(file.url as string);
      return {
        fileName: matched?.fileName || file.name,
        base64File: matched?.base64File || "",
      };
    })
  );

  const files = await Promise.all(
    attachmentFiles.map(async (file) => {
      if (file.originFileObj) return await convertFile(file);
      const matched = fileMap.get(file.url as string);
      return {
        fileName: matched?.fileName || file.name,
        base64File: matched?.base64File || "",
      };
    })
  );

  return { images, files };
};
